import * as React from "react";
import styled, { css } from "styled-components";
import Alert from "./Alert";
const StyledAlert = styled(Alert)(
  ({ theme, $padding }) => css`
    background-color: ${theme.colors.variant.lightest.default};
    border-color: ${theme.colors.variant.light.default};
    margin-top: 0;
    padding: ${$padding === "small" ? theme.spacings.sm : theme.spacings.md};

    .mantine-Alert-message {
      color: ${theme.colors.variant.darker.default};
    }
  `
);
const Well = (props) => /* @__PURE__ */ React.createElement(StyledAlert, { noIcon: true, $padding: props.bsSize, ...props });
export default Well;
